//As default Webpack will not make function globally available, to not litter the global scope.
//If you want the function to be accessible outside the scope of the JS file, you should put it in the global scope.

function toggleMenu(element) {
    let parentElement = element.parentElement;

    if (parentElement.classList.contains("is-open")) {
        parentElement.classList.remove("is-open");
    } else {
        parentElement.classList.add("is-open");
    }
}

//global scope
window.toggleMenu = toggleMenu;